import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";

interface AddressInformationProps {
  street: string;
  postalCode: string;
  city: string;
  country: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AddressInformation = ({
  street,
  postalCode,
  city,
  country,
  onChange
}: AddressInformationProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 mb-3">{t("companies.createModal.addressLabel")}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <label htmlFor="street" className="block text-sm font-medium text-gray-700 mb-1">
            {t("companies.createModal.streetLabel")}
          </label>
          <Input
            id="street"
            value={street}
            onChange={onChange}
          />
        </div>
        
        <div>
          <label htmlFor="postal_code" className="block text-sm font-medium text-gray-700 mb-1">
            {t("companies.createModal.postalCodeLabel")}
          </label>
          <Input
            id="postal_code"
            value={postalCode}
            onChange={onChange}
          />
        </div>
        
        <div>
          <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
            {t("companies.createModal.cityLabel")}
          </label>
          <Input
            id="city"
            value={city}
            onChange={onChange}
          />
        </div>
        
        <div>
          <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1">
            {t("companies.createModal.countryLabel")}
          </label>
          <Input
            id="country"
            value={country}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};
